export default __webpack_public_path__ + "static/media/magazine_banner.9d5623ff.png";